module.exports = __webpack_public_path__ + "static/media/2_Price.d73a93a6.png";